package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ParentNoteReplyCreateRequest(
    val message: String,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String> = emptyList()
)
